import * as React from 'react'

import BusinessTripRatesContainer from './businessTripRatesContainer'
import { RouteComponentProps } from '@/app/navigation/withRouter'

export const BusinessTripRatesContent = ({
  match,
}: RouteComponentProps<{ companyId: string }>) => {
  return (
    <div data-testid="business-trip-rates-page" className='tw-h-[calc(100vh-120px)]'>
      <BusinessTripRatesContainer companyId={match.params.companyId} />
    </div>
  )
}
